import React from 'react';
import { NavLink } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = () => {
  const menuItems = [
    { path: '/dashboard', icon: '🏠', label: 'Home' },
    { path: '/dashboard/invoices', icon: '🧾', label: 'Invoices' },
    { path: '/dashboard/invoice-settings', icon: '🗂️', label: 'Invoice Settings' },
    { path: '/dashboard/website-settings', icon: '🌐', label: 'Website Settings' },
    { path: '/dashboard/contact-inquiries',  icon: '💬', label: 'Inquiries' },
    { path: '/dashboard/profile', icon: '👤', label: 'Profile' },
    { path: '/dashboard/settings', icon: '⚙️', label: 'Settings' },
    { path: '/dashboard/analytics', icon: '📊', label: 'Analytics' },
    { path: '/dashboard/reports', icon: '📄', label: 'Reports' },
  ];

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2>Dashboard</h2>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              isActive ? 'nav-item active' : 'nav-item'
            }
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
